import { getConfig } from "../../../config/app";
import { isDevEnv } from "../../utils/env";

type GetHostname = (countryCode: string) => string;
export const getHostname: GetHostname = countryCode =>
  isDevEnv ? "" : getConfig(`urls.${countryCode}.home`);
